const AUTH_KEY = 'auth';

export const getAuthKey = (): string | null => {
    return localStorage.getItem(AUTH_KEY);
};
